import { createSelector } from '@reduxjs/toolkit';
import { resourceSelectors } from '../../utils/resourceSelectors';
import { investmentStrategyDocumentsById } from './investmentStrategyDocuments';

export const [
  investmentStrategiesAllIds,
  investmentStrategiesById,
  investmentStrategiesSelector,
  investmentStrategiesMetadataSelector,
] = resourceSelectors('investmentStrategies');

export const investmentStrategyByIdSelector = (id) =>
  createSelector(investmentStrategiesById, (byId) => byId[id]);

export const investmentStrategyDocumentsRelationshipSelector = (id) =>
  createSelector(investmentStrategyByIdSelector(id), (strategy) => {
    const documents = strategy?.investmentStrategyDocuments;
    if (!Array.isArray(documents) || !documents.length) {
      return [];
    }

    return documents.filter(
      (document) => typeof document?.id === 'string' && document.id
    );
  });

export const investmentStrategyDocumentsByStrategyIdSelector = (id) =>
  createSelector(
    investmentStrategyDocumentsRelationshipSelector(id),
    investmentStrategyDocumentsById,
    (relationshipDocuments, documentsById) => {
      return relationshipDocuments
        .map((document) => documentsById?.[document.id])
        .filter(Boolean);
    }
  );

export const investmentStrategyPortfolioManagementAgreementContentSelector = (
  id
) =>
  createSelector(
    investmentStrategyDocumentsByStrategyIdSelector(id),
    (documents) => {
      const agreementDocument = documents.find(
        (document) =>
          document?.documentType === 'portfolioManagementAgreement'
      );

      if (!agreementDocument) {
        return null;
      }

      if (agreementDocument.contentType !== 'text/markdown') {
        return null;
      }

      return typeof agreementDocument.content === 'string'
        ? agreementDocument.content
        : null;
    }
  );

export const allInvestmentStrategiesSelector = createSelector(
  investmentStrategiesSelector,
  (investmentStrategy) => {
    return investmentStrategy.filter((item) => item.id);
  }
);

export const publishedInvestmentStrategiesSelector = createSelector(
  allInvestmentStrategiesSelector,
  (investmentStrategy) => {
    const publishedStatuses = [
      'selected',
      'active',
      'pendingsignature',
      'signed',
      'archived',
    ];
    return investmentStrategy.filter(
      (item) =>
        publishedStatuses.includes(item?.status?.toLowerCase()) &&
        !Boolean(item?.migrated)
    );
  }
);
